import * as React from 'react';
import { Link } from 'react-router';
import { ChevronRight } from 'lucide-react';

export interface Crumb {
  label: string;
  to?: string;
}

export interface BreadcrumbProps {
  crumbs: Crumb[];
}

// Per design spec (04-global-components.html §1 + README §4a).
// Link for non-final crumbs, bold (500) span for the current page; 13px.
export function Breadcrumb({ crumbs }: BreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 13,
        color: 'var(--text-muted)',
        marginBottom: 16,
      }}
    >
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <React.Fragment key={`${c.label}-${i}`}>
            {i > 0 && (
              <ChevronRight
                size={13}
                color="var(--border)"
                style={{ flexShrink: 0 }}
                aria-hidden="true"
              />
            )}
            {isLast || !c.to ? (
              <span
                aria-current={isLast ? 'page' : undefined}
                style={{
                  color: isLast ? 'var(--text-primary)' : 'var(--text-secondary)',
                  fontWeight: isLast ? 500 : 400,
                }}
              >
                {c.label}
              </span>
            ) : (
              <Link
                to={c.to}
                style={{
                  color: 'var(--text-secondary)',
                  textDecoration: 'none',
                  fontWeight: 400,
                }}
              >
                {c.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default Breadcrumb;
